import { useEffect } from 'react'
import useEP from './useEP'
import { getFamilyTreeData } from '../services/services'

const useFamilyTreeData = (generations) => {
  const [state, dispatch, fn] = useEP(getFamilyTreeData)

  useEffect(() => {
    // initial component onload useEffect
    dispatch({ type: 'load' })
  }, [dispatch])

  useEffect(() => {
    let subscribe = true
    const { load } = state

    if (load && subscribe) {
      getFamilyTreeData(generations).then((res) => {
        dispatch({ type: 'complete', res })
      })
    }

    return () => {
      subscribe = false
    }
  }, [dispatch, generations, state])

  return [state, dispatch, fn]
}

export default useFamilyTreeData
